export const titles = (state) => state.titles;